import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';

export const MODAL_SLICE_ID = 'modal';

export interface ModalState {
  modalId: string;
  modalParams?: Record<string, any>;
}

const initialState: ModalState = {
  modalId: '',
  modalParams: undefined,
};

const modalSlice = createSlice({
  name: MODAL_SLICE_ID,
  initialState,
  reducers: {
    showModal: (state: ModalState, action: PayloadAction<ModalState>) => {
      const { payload } = action;
      state.modalId = payload.modalId;
      state.modalParams = payload.modalParams;
    },
    hideModal: (state: ModalState) => {
      state.modalId = '';
      state.modalParams = undefined;
    },
  },
});

export const { showModal, hideModal } = modalSlice.actions;

export const selectModalId = (state: RootState) => state.modal.modalId;
export const selectModalParams = (state: RootState) => state.modal.modalParams;

export default modalSlice;
